const actions = {
  setEquipmentFilter: ({ commit }, payload) => {
    commit('SET_EQUIPMENT_FILTER', payload);
  },
  setTotalEquipment: ({ commit }, payload) => {
    commit('SET_TOTAL_EQUIPMENT', payload);
  },
  setSearchQuery: ({ commit }, payload) => {
    commit('SET_SEARCH_QUERY', payload);
  },
  setPaginationQuery({ commit }, payload) {
    commit('SET_PAGINATION_QUERY', payload);
  },
  clearQueries({ commit }) {
    commit('SET_PAGINATION_QUERY', { data: {} });
  },
  refreshTable: ({ commit }) => {
    commit('REFRESH_TABLE');
  },
  setTotalFilteredEquipment: ({ commit }, payload) => {
    commit('SET_TOTAL_FILTERED_EQUIPMENT', payload);
  },
  clearFilterAndSearch: ({ commit }) => {
    commit('CLEAR_FILTER_AND_SEARCH');
  },
  addSelected: ({ commit }, payload) => {
    let newSelected = {};

    payload.data.forEach((equipment) => {
      newSelected[equipment[payload.key]] = {
        id: equipment.id,
        name: equipment.name,
      };
    });

    commit('ADD_SELECTED', { data: newSelected });
  },
  removeSelected: ({ commit }, payload) => {
    commit('REMOVE_SELECTED', payload);
  },
  clearSelected: ({ commit }, payload) => {
    commit('CLEAR_SELECTED', payload);
  },
};

export { actions };
